const withdrawIntentDictES = {
  paypalEmail: "Ingrese el correo electrónico del PayPal a continuación",
  amountWithdrawn: "Valor retirado de la billetera",
  amountDeposited: "Valor depositado en el PayPal",
  withdrawFee: "tarifa de retiro",
  paypalFee: "PayPal aplicará una comisión del",
  onTop: "sobre el importe transferido",
  requestWithdraw: "Solicitar retiro",
  amountWithdrawnSuccessfully: "Valor retirado con éxito!",
  invalidemail: "Correo electrónico inválido",
  withdrawRequests: "Solicitudes de retiro",
  requestDate: "Fecha de solicitud",
  processDate: "Fecha de procesamiento",
  processing: "Procesando",
  amountToDeposit: "La cantidad a depositar",
  amountRequested: "Monto requerido",
  processRequest: "Procesa solicitud",
  process: "Proceso",
  withdrawProcessedSuccessfully: "¡Solicitud de retiro procesada con éxito!",
  withdrawWith: "Retirar con",
  bank: "Banco",
  bankName: "Nombre del banco",
  bankAccountNumber: "Número de cuenta bancaria",
  accountOwner: "Nombre del titular de la cuenta",
  allFieldsRequired: "Todos los campos son obligatorios",
  previousBankDataFound: "Datos bancarios anteriores encontrados:",
  previousPaypalEmailsFound: "Correos electrónicos de PayPal anteriores encontrados:",
  clickToUseOrTypeNew: "Haga clic para usar o escriba uno nuevo",
  cashbackForBuyer: "Cashback para el comprador",
  cashbackToBuyersSponsor: "Cashback para el patrocinador del comprador",
  cashbackToSellersSponsor: "Cashback para el patrocinador del vendedor",
  amountToBeReceived: "Cantidad a recibir",
  withdrawalRequestsPageTitle: "Solicitudes de retiro",
  withdrawalRequestsSubtitle: "Historial de solicitudes de retiro realizadas.",
  account: "Cuenta",
  amountToTransfer: "Valor a transferir",
  fee: "Comisión",
  noWithdrawalRequests: "Aún no hay solicitudes de retiro.",
};

export default withdrawIntentDictES;
